import { applyRateBigNumber, applyRateBigNumberToFloat } from '@/util/big'

export const useConvertNativeCurrencyToFiat = () => applyRateBigNumberToFloat
export const useConvertNativeCurrencyToSwEth = () => applyRateBigNumber
export const useConvertNativeCurrencyToRswEth = () => applyRateBigNumber
export const useConvertSwEthToFiat = () => applyRateBigNumberToFloat
export const useConvertSwEthToNativeCurrency = () => applyRateBigNumber
export const useConvertRswEthToFiat = () => applyRateBigNumberToFloat
export const useConvertRswEthToNativeCurrency = () => applyRateBigNumber
